var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLWysiwygOutput",class:_vm.classList,style:(_vm.styleVars)},[(!_vm.usingSlot)?_c('div',{staticClass:"LLWysiwygOutput__html",domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }